/*
 Currently designed specifically for PreChat Message views
 */
import Animation from './hooks/Animation';
import MessageStatus from './hooks/MessageStatus';
import MessageVisibility from './hooks/MessageVisibility';
import PreChatMessageAnimations from './hooks/PreChatMessageAnimations';
import SimpleView from './SimpleView';
import getValuesOfObjectAsArray from './hooks/getValuesOfObjectAsArray';
import showElement from './hooks/showElement';

export default class MessageView {
    constructor(options) {
        if (!options) {
            return this.create(); // in case of page reloads
        }
        const me = this;
        this.status = options && options.status;
        this.visibility = options && options.visibility;

        this.index = options && options.index;
        this.model = options && options.model;
        this.targetElementSelector = options && options.targetElementSelector;
        this.renderOninit = options && options.renderOninit;
        this.isLastMessage = true;
        this.isFirstMessage = true;
        // the html part of the message
        me.view = new SimpleView({
            context: options.context,
            identifier: `${this.model.messageTypeText}_${this.model.id}`,
            template: options.template,
            model: this.model,
            containerSelector: '.apexchat_prechat_message_bubble',
            wrap: options.wrap,
            rawContent: this.model.message,
            renderOninit: this.renderOninit,
            targetElementSelector: this.targetElementSelector,
            isTemplateAlreadyParsed: true,
            beforeRender() {
                this.template =
                    this.template ||
                    ApexChat.preChatMsgTemplate ||
                    ApexChat.sessionAPI.Get('livechat_prechat_msg_template');
                this.template = this.template
                    .replace('##message##', this.rawContent)
                    .replace('apexchat_prechat_message_popup', this.identifier);
            },
            afterRender() {
                ApexChat.preChatElement = this.context.querySelector(`#${this.identifier}`);
                const el = this.context.querySelector(`#${this.identifier}`);
                showElement(el, true);
            }
        });
        // the following keeps all sorts of animations available in the message so we can invoke one by animate()
        me.animations = {};
        const animationTypes = getValuesOfObjectAsArray(PreChatMessageAnimations);
        for (let i = 0; i < animationTypes.length; i++) {
            const animationName = animationTypes[i];
            // var animation = ApexChat.PreChatMessageAnimations[animationName];
            me.animations[animationName] = new Animation({
                name: animationName,
                runAfter: 1, // 1 = 1ms, 1000 = 1sec
                animationFunction(animationCss) {
                    me.view.addClass(animationCss);
                }
            });
        }
        this.animationTypes = animationTypes;
    }

    // used to invoke an animation by name
    animate(animation, time) {
        let _animation;
        if (!animation) {
            _animation = this.animations[PreChatMessageAnimations.First];
        } else {
            _animation = this.animations[animation];
        }
        _animation.start(time);
    }

    // used to create an empty message on reloads
    create() {
        this.status = MessageStatus.Unread;
        this.visibility = MessageVisibility.Visible;
        this.animation = PreChatMessageAnimations.Appeared;
        this.index = 0;
        this.model = {};
        this.targetElementSelector = '';
        return this;
    }

    // after creating a default message using create(), fill in it by parsing the actual message taken out from the cache
    parse(messageView) {
        this.status = messageView.status;
        this.visibility = messageView.visibility;
        this.index = messageView.index;
        this.model = messageView.model;
        this.targetElementSelector = messageView.targetElementSelector;
        this.renderOninit = messageView.renderOninit;
        this.isLastMessage = messageView.isLastMessage;
        this.isFirstMessage = messageView.isFirstMessage;
        this.view = new SimpleView({
            context: this.context,
            identifier: this.model.id,
            template: messageView.view.template,
            model: this.model,
            wrap: messageView.view.wrap,
            rawContent: messageView.view.rawContent,
            renderOninit: this.renderOninit,
            targetElementSelector: this.targetElementSelector
        });
    }

    // used to detect which animation a message is in currently
    getCurrentAnimatedState() {
        for (let i = 0; i < this.animations.length; i++) {
            if (this.animations[i].isActive()) {
                return this.animations[i].name;
            }
        }
    }

    isRead() {
        return this.status === MessageStatus.Read;
    }

    isVisible() {
        return this.visibility === MessageVisibility.Visible;
    }

    getMessageType() {
        return this.model.messageType; // ApexChat.ScriptsQuestionType
    }
}
